import React from 'react';

import ProductRating from './product-rating';
import BvRating from '../../bv/components/bv-rating';
import '../../product/css/product-show.less';

const ProductDetailRow = props => {
    let { product, displayAvgRating=false, displaySkuID=true } = props;
    const { prdClass } = product;
    let numReviews = `(${product.numReviews})`;
    let sku = product.sku && product.sku.replace(/^P_/i,"");
    let rating;
    const isExternalSku = prdClass === 'EXT';
    try{
        rating = product.rating.toFixed(1);
    }catch(e){}
    let content = !isExternalSku ?
        <div>
            <ProductRating rating={product.rating} />
            {displayAvgRating && rating ? <span className="avg-rating">{rating}</span> : null}
            <span className="num-reviews">{numReviews}</span>
            {props.pdp ? <span className="button">{"Write a review"}</span> : null}
        </div> : null;
    return (
        <div className="prd-hdr-2">
            <div className="reviews-row">
                {props.pdp && !isExternalSku ? <BvRating product={product} sku={sku} onRatingsClick={props.changeTab} placeHolder={content}/> : content}
            </div>               
            {displaySkuID && <div className='product-sku'>{sku}</div>}
            {product.prdClass === "PRT" && props.pdp && <div className='product-number'><span>Product #: </span>{sku}</div>}
            {product.attributes && product.attributes.hasOwnProperty("energyeffcomp") &&
                 <div className="energy-star">ENERGY STAR</div>
             }
        </div>
    );
};

export default ProductDetailRow;